<template>
  <NebulaSelect>
    <template #select>
      <select
        class="nebula-select__element"
        :aria-disabled="ariaDisabled"
        :value="buttonStyle"
        @change="updateButtonStyle"
      >
        <NebulaSelectOption
          :option="{
            text: selectText('nebulaDefault'),
            value: '',
          }"
        />
        <NebulaSelectOption
          :option="{
            text: selectText('mysteryDefault'),
            value: 'mystery-science',
          }"
        />
      </select>
    </template>
  </NebulaSelect>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import { cloneDeep, get, set } from 'lodash-es';
import { NebulaSelect, NebulaSelectOption } from '@discoveryedu/nebula-components';
import { UPDATE_MODULE } from '@/lib/constants/store';
import { getThemeDefaults } from '@/lib/utils/store';
import {
  useEditorStore,
} from '@/stores';

export default {
  components: {
    NebulaSelect,
    NebulaSelectOption,
  },
  props: {
    canvasName: {
      type: String,
      required: true,
    },
    moduleData: {
      type: Object,
      required: true,
    },
    property: {
      type: String,
      default: 'options.button_style',
    },
    ariaDisabled: {
      type: String,
      default: 'false',
    },
  },
  computed: {
    buttonStyle() {
      return get(this.moduleData, this.property);
    },
    ...mapState(useEditorStore, [
      'currentPage',
    ]),
    themeName() {
      return (get(this, 'currentPage.options.theme.name'));
    },
  },
  methods: {
    ...mapActions(useEditorStore, [
      UPDATE_MODULE,
    ]),
    updateButtonStyle(e) {
      const data = cloneDeep(this.moduleData);
      set(data, this.property, e.target.value || undefined);
      this[UPDATE_MODULE]({ canvasName: this.canvasName, payload: data });
    },
    selectText(type) {
      return getThemeDefaults(this.themeName)[type];
    },
  },
};
</script>
